<template>
  <dashboard-modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="
          selectedUrl
            ? `/accreditationtechnical/nonConformitiesReviewCorrectiveActions/update/${inputs.id}`
            : `/accreditationtechnical/nonConformitiesReviewCorrectiveActions/update/`
        "
      >
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group row align-items-center">
              <label for="inputs_name" class="col-sm-3 mb-0">
                {{ $t("Categoría") }}
              </label>
              <p
                id="inputs_type"
                v-if="inputs.type == 'NC'"
                style="margin-top: 15px; margin-left: 20px"
              >
                <strong class="text-danger">NO CONFORMIDAD</strong>
              </p>
              <p
                id="inputs_type"
                v-if="inputs.type == 'C'"
                style="margin-top: 15px; margin-left: 20px"
              >
                <strong class="text-danger">COMENTARIO</strong>
              </p>
            </div>

            <div class="form-group row align-items-center">
              <label for="inputs_name" class="col-sm-3 mb-0">
                {{ $t("Requisito") }}
              </label>
              <p
                id="inputs_requirement"
                style="margin-top: 15px; margin-left: 20px"
              >
                <strong class="text-primary">{{ inputs.requirement }}</strong>
              </p>
            </div>

            <div class="form-group row align-items-center">
              <label for="inputs_name" class="col-sm-3 mb-0">
                {{ $t("Reiterada") }}
              </label>
              <p id="inputs_name" style="margin-top: 15px; margin-left: 20px">
                <strong
                  class="text-primary"
                  v-if="inputs.repeated_after_last_evaluation == '0'"
                  >NO</strong
                >
                <strong
                  class="text-primary"
                  v-if="inputs.repeated_after_last_evaluation > 0"
                  >SI</strong
                >
              </p>
            </div>

            <div class="form-group row align-items-center">
              <label for="inputs_name" class="col-sm-3 mb-0">
                {{ $t("Hallazgo") }}
              </label>
              <app-input
                id="inputs_finding"
                class="col-sm-9"
                type="textarea"
                v-model="inputs.finding"
                disabled
              />
            </div>
            <div class="form-group row align-items-center">
              <label for="inputs_name" class="col-sm-3 mb-0">
                {{ $t("Evidencia") }}
              </label>
              <app-input
                id="inputs_evidence"
                class="col-sm-9"
                type="textarea"
                v-model="inputs.evidence"
                disabled
              />
            </div>

            <div class="form-group row align-items-center">
              <label for="inputs_name" class="col-sm-3 mb-0">
                {{ $t("Evidencias satisfactorias") }}
              </label>
              <app-input
                type="radio-buttons"
                class="col-sm-9"
                v-model="inputs.is_satisfactory"
                :list="list"
              />
            </div>
            <legend
              class="row col-12 col-form-label text-primary pt-0 mt-3 mb-3"
            >
              <h5>Respuesta</h5>
            </legend>
            <div class="form-group row align-items-center" v-if="inputs.finding_1">
              <label for="inputs_name" class="col-sm-4 mb-0">
                {{ $t("Adjunto") }}
              </label>
              <a
                :href="inputs.finding_1.full_url"
                class="btn btn-success col-sm-7"
                target="_blank"
              >
                <app-icon name="file" />
              </a>
            </div>
            <div class="form-group row align-items-center">
              <label for="inputs_name" class="col-sm-3 mb-0">
                {{ $t("Acciones correctivas") }}
              </label>
              <app-input
                id="inputs_comment_1"
                class="col-sm-9"
                type="textarea"
                v-model="inputs.corrective_actions_1"
                disabled
              />
            </div>
            <div class="form-group row align-items-center">
              <label for="inputs_name" class="col-sm-3 mb-0">
                {{ $t("Comentario") }}
              </label>
              <app-input v-if="!showObservations"
                id="inputs_comment_1"
                class="col-sm-9"
                type="textarea"
                v-model="inputs.comment_1"
              />

              <app-input v-if="showObservations"
                id="inputs_comment_1"
                class="col-sm-9"
                type="textarea"
                v-model="inputs.comment_1"
                disabled
              />
            </div>
            <legend
              class="row col-12 col-form-label text-primary pt-0 mt-3 mb-3"
              v-if="showObservations"
            >
              <h5>Respuesta Segunda Instancia</h5>
            </legend>
            <div
              class="form-group row align-items-center"
              v-if="showObservations"
            >
              <label for="inputs_name" class="col-sm-3 mb-0">
                {{ $t("Acciones Correctivas Segunda Instancia") }}
              </label>
              <app-input
                v-if="inputs.type == 'NC'"
                id="inputs.comment_1"
                class="col-sm-9"
                type="textarea"
                v-model="inputs.corrective_actions_2"
                :disabled="showObservations"
              />
            </div>

            <div
              class="form-group row align-items-center"
              v-if="showObservations"
            >
              <label for="inputs_name" class="col-sm-3 mb-0">
                {{ $t("Comentario segunda instancia") }}
              </label>
              <app-input
                id="inputs.comment_2"
                class="col-sm-9"
                type="textarea"
                v-model="inputs.comment_2"
              />
            </div>

            <div class="form-group row align-items-center" v-if="inputs.finding_2">
              <label for="inputs_name" class="col-sm-4 mb-0">
                {{ $t("Adjunto") }}
              </label>
              <a
                :href="inputs.finding_2.full_url"
                class="btn btn-success col-sm-7"
                target="_blank"
              >
                <app-icon name="file" />
              </a>
            </div>
          </div>
        </div>
      </form>
    </template>
  </dashboard-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";

export default {
  name: "ApplicacionAddModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    accreditationEmployeList: Array,
    additional: Number,
  },
  data() {
    return {
      preloader: false,
      inputs: {},
      showObservations: false,
      request: {},
      modalId: "corrective-add-edit-modal",
      modalTitle: this.$t("add"),
      list: [
        {
          id: "0",
          value: "No",
        },
        {
          id: "1",
          value: "Si",
        },
      ],
    };
  },

  created() {
    if (this.additional == 1) {
      this.showObservations = true;
    }
  },
  methods: {
    submit() {
      this.save(this.inputs);
    },
    afterSuccess(response) {
      this.$toastr.s(this.$t("updated_success"));
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      if (response.data.phone) this.phone = response.data.phone;
      this.inputs = response.data;
      if (response.data.finding_1) {
        this.inputs.file = response.data.finding_1.full_url;
      }

      this.preloader = false;
    },
  },
};
</script>